export const FETCH_MOVIES = 'FETCH_MOVIES';
export const FETCH_DETAIL_MOVIE = 'FETCH_DETAIL_MOVIE';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_QUERY = 'SET_QUERY';
export const RESET_ITEMS = 'RESET_ITEMS';